import React from 'react'
import { useParams } from 'react-router-dom'
import useSWRMutation from 'swr/mutation'
import { mutate } from 'swr'
import { putFetcher } from 'api/swr'
import Selector from 'components/ui/Selector'
import { CptPrices } from 'config'
import {
  getProPermissionErrorMessage,
  useProCptPermission,
} from 'hooks/useProCptPermission'
import { useToast } from '@/components/ui/use-toast'

const CptProSelector = ({ cpt }) => {
  const { tid } = useParams()
  const { toast } = useToast()
  const { canSetProCpt, isLoading } = useProCptPermission()
  const { trigger, isMutating } = useSWRMutation(
    `/components/${cpt.id}`,
    putFetcher,
  )

  const handleChange = (value) => {
    if (!canSetProCpt) return
    const next = Number(value)
    if (isMutating || next === (cpt.pro ?? 0)) return
    trigger(
      { tid, key: 'pro', value: next },
      {
        onSuccess: () => {
          mutate(['/components', { tid }])
        },
        onError: (err) => {
          toast({
            variant: 'destructive',
            title: '无法设置 pro 价格',
            description: getProPermissionErrorMessage(err),
          })
        },
      },
    )
  }

  if (!isLoading && !canSetProCpt) {
    return (
      <div
        className="flex h-8 min-w-0 flex-1 items-center justify-center rounded-md border bg-muted px-2 text-xs text-muted-foreground"
        onClick={(e) => e.stopPropagation()}
        title="无 pro 设置权限"
      >
        {cpt.pro ?? 0}
      </div>
    )
  }

  return (
    <div
      className="min-w-0 flex-1"
      onClick={(e) => e.stopPropagation()}
    >
      <Selector
        labelName="pro"
        value={cpt.pro ?? 0}
        datas={CptPrices}
        update={handleChange}
        width="w-full"
        className="h-8"
        placeholder={isLoading ? '...' : undefined}
      />
    </div>
  )
}

export default CptProSelector
